module.exports = __webpack_public_path__ + "static/media/tr.ce2e2e8e.svg";